import React, { useState } from 'react';
import DataTable from '@preflighttech/preflight-tables';

import {
  MainContainer,
  ContentContainer,
  PageTitle,
} from 'app/src/elements';
import { currency } from 'app/src/utils/stringHelpers';
import { dateShort } from 'app/src/utils/timeFormatter';
import { Link, useParams } from 'app/src/utils/routing';

import { TXN_LINES_WITH_COUNT } from './queries';

const columns = [
  {
    key: 'id',
    label: 'Line ID',
  },
  {
    key: 'txnId',
    label: 'Txn ID',
    value: ({ entry }) => entry.txn.id,
    content: ({ entry, value }) => (
      <Link to={`/accounting/transactions/${entry.txn.id}`}>{value}</Link>
    ),
  },
  {
    key: 'bankDate',
    label: 'Date',
    sort: 'desc',
    value: ({ entry }) => entry.txn.bankDate,
    content: dateShort,
  },
  {
    key: 'debitLessCredit',
    label: 'Debit',
    cellStyle: ({ textAlign: 'right' }),
    content: ({ value }) => value >= 0 ? currency(value) : ''
  },
  {
    key: 'creditLessDebit',
    label: 'Credit',
    cellStyle: ({ textAlign: 'right' }),
    content: ({ value }) => value > 0 ? currency(value) : ''
  },
  {
    key: 'stockNumber',
    label: 'Stock #',
    sort: 'prevent',
    value: ({ entry }) => entry.asset?.stockNumber
  },
  {
    key: 'saleOn',
    label: 'Sale',
    sort: 'prevent',
    value: ({ entry }) => entry.saleAsset?.sale?.saleOn,
    content: dateShort,
  },
  {
    key: 'lotNumber',
    label: 'Lot #',
    value: ({ entry }) => entry.saleAsset?.lotNumber,
  },
];

const TxnLines = () => {
  const [refetch, setRefetch] = useState();
  const [resource, setResource] = useState();

  const queryVariables = {
    resourceType: useParams().type,
    resourceId: useParams().id,
  };

  return (
    <MainContainer>
      <ContentContainer>
        <PageTitle>
          Register
          {resource && (
            <Link to={resource.path}>{' - '}{resource.name}</Link>
          )}
        </PageTitle>

        <DataTable.Gql
          setRefetch={setRefetch}
          query={TXN_LINES_WITH_COUNT}
          queryName='txnLinesWithCount'
          queryVariables={queryVariables}
          dataUpdated={data => setResource(data?.resource)}
          columns={columns}
          pageLength={25}
          lengthMenu={ [10, 25, 50, 100, 200, 500] }
          htmlTable
        />
      </ContentContainer>
    </MainContainer>
  );
};

export default TxnLines;
